import React from "react";
import { useState, useEffect, useContext } from "react";
import indicator_icon from "../images/Indicator.gif";
import "./forgotPasswordForm.css";
import axios from "axios";
import SglContext from '../SglContext'


function ForgotPasswordForm() {
  const [emailAddress, setEmailAddress] = useState("");
  const [loading, setLoading] = useState(true);
  const Sgl = useContext(SglContext)
  const css = '.sgl-plugin-page #sgl-content-wrapper{padding-bottom: 20px;max-width: 600px;margin: 0px;}';

  //API END POINTS
  const sgl_webservice_process_forgot_password =
  Sgl.sglApiUrl +
  "/iphone.php/webservice/ProcessForgotPassword";

  useEffect(() => {
    let sgl_plugin_form = document.getElementById("sgl-plugin-form");
    sgl_plugin_form.style.display = "block";
    Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_urlpath + '/forgotpassword');
    Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_urlpath + '/forgotpassword');
  }, []);

  function processForgotPassword() {
    let email = document.getElementById("email");
    let sgl_plugin_form = document.getElementById("sgl-plugin-form");
    let sgl_plugin_success_message = document.getElementById(
      "sgl-plugin-success-message"
    );
    let errorContainer = document.getElementById("reg_error_summary");

    errorContainer.innerHTML = "";
    errorContainer.style.display = "none";
    // this.setState({ email_address: email.value });
    setEmailAddress(email.value);

    axios
      .post(sgl_webservice_process_forgot_password, null, {
        params: {
          email: email.value,
          customer_id: Sgl.company_id,
          site_url: `${window.location.protocol}//${window.location.host}${(Sgl.basePath != '/' && Sgl.basePath != '')?`${Sgl.basePath}`:""}`,
        },
      })
      .then((response) => {
        if (response.data.status) {
          sgl_plugin_form.innerHTML = "";
          sgl_plugin_form.style.display = "none";
          sgl_plugin_success_message.style.display = "block";
        } else {
          errorContainer.innerHTML = response.data.message;
          errorContainer.style.display = "block";
        }
      });
  }

  return (
    <div className='sgl-content-wrapper forgotPasswordformcss'>
      <style>{css}</style>
      <div className='sgl-plugin'>
        <div className='forgot_password_header'>
          <h1>FORGOT PASSWORD</h1>
        </div>

        {/* form start */}
        <div id='sgl-plugin-form'>
          <div className='div-responsive'>
            <div className='forgot-password-container'>
              <div className='fp_message'>
                <div>
                  <p>
                    <b>RESET PASSWORD</b>
                    <br />
                    Please type your Email / User Name to reset your password.
                  </p>
                </div>
              </div>

              <div className='full'>
                <input
                  type='text'
                  placeholder='Email / User Name'
                  name='email'
                  id='email'
                  className='forgotpw'
                />
              </div>

              <div className='error_container'>
                <div>
                  <p
                    className='error_summary reg_error_summary'
                    id='reg_error_summary'></p>
                </div>
              </div>

              <div className='full submit'>
                <input
                  type='button'
                  id='update'
                  className='button'
                  onClick={processForgotPassword}
                  value='Submit'
                />
                <span id='please-wait'>
                  <img src={indicator_icon} /> Verifiying...
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* form end */}

        <div id='sgl-plugin-success-message'>
          <p>
            <b>Email Sent</b>
            <br />
            An email containing a link to reset your password has been sent to{" "}
            {emailAddress}. Please check your email.
          </p>
        </div>
      </div>
    </div>
  );
}
// ReactDOM.render(<ForgotPasswordForm />, document.getElementById("sgl-content-wrapper"));
export default ForgotPasswordForm;
